export default __webpack_public_path__ + "static/media/sun-horizon.14ae44a2.svg";